import React from "react";
import { TrendingUp } from "lucide-react";
import { ProfitOverview } from "./ProfitOverview";

export default function AdminSales() {
  return (
    <div className="p-4 md:p-8 max-w-[1000px]" data-testid="admin-sales-page">
      <h1 className="text-white text-2xl lg:text-3xl font-bold flex items-center gap-3 mb-6">
        <TrendingUp className="w-6 h-6 text-[#c5a76f]" /> Winst & verkoop
      </h1>
      <ProfitOverview />
    </div>
  );
}
